import request from '@/services/interceptor.js'

// --- Calendario Eventi ---

export const get_eventi = (par) => {
    return request({
        url: '/dati/eventi',
        method: 'post',
        data: par,
        loadingBar: false
    })
}

export const salva_evento = (dati) => {
    return request({
        url: '/dati/salva',
        method: 'post',
        data: dati,
        loadingBar: true
    })
}

export const elimina_evento = (dati) => {
    return request({
        url: '/dati/elimina',
        method: 'delete',
        data: dati,
        loadingBar: true
    })
}

export const conferma_evento = (dati) => {
    return request({
        url: '/dati/conferma',
        method: 'post',
        data: dati,
        loadingBar: true
    })
}

export const rifiuta_evento = (dati) => {
    return request({
        url: '/dati/rifiuta',
        method: 'post',
        data: dati,
        loadingBar: true
    })
}

export const annulla_stato_evento = (dati) => {
    return request({
        url: '/dati/annulla-stato',
        method: 'post',
        data: dati,
        loadingBar: true
    })
}

export const verifica_sovrapposizione = (dati) => {
    return request({
        url: '/dati/verifica-sovrapposizione',
        method: 'post',
        data: dati,
        loadingBar: false
    })
}

// --- Dati Generali ---

export const get_tipo_eventi = (tipo) => {
    return request({
        url: '/dati/tipo-eventi',
        method: 'get',
        params: { tipo },
        loadingBar: false
    })
}

export const get_utenti = () => {
    return request({
        url: '/dati/utenti',
        method: 'get',
        loadingBar: false
    })
}